import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/utils/cn'

/** Password field with a show/hide toggle. `show` is UI-only state. */
export function PasswordInput({
  value,
  onChange,
  placeholder,
  invalid,
  className,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  invalid?: boolean
  className?: string
}) {
  const [show, setShow] = useState(false)
  return (
    <div className="relative">
      <Input
        type={show ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        className={cn('pr-9', invalid && 'border-destructive/50', className)}
      />
      <button
        type="button"
        onClick={() => setShow(v => !v)}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground max-md:after:absolute max-md:after:-inset-3"
      >
        {show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
      </button>
    </div>
  )
}
